// @flow

import * as React from "react";
import { isUndefined } from "lodash";
// $FlowIgnore
import * as Sentry from "@sentry/browser";

// Remove the following typedef once this is properly exposed.
// https://github.com/facebook/flow/issues/5139
type ErrorInfo = {
  componentStack: string
};

type Props = {
  children: React.Node
};

type State = {
  error: ?Error,
  errorInfo: ?ErrorInfo
};

// window.environment is set by Python's app.
// noinspection JSUnusedLocalSymbols
declare var environment: "debug" | "staging" | "production";

export default class SentryBoundary extends React.Component<Props, State> {
  state = {
    error: null,
    errorInfo: null
  };

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error: error, errorInfo: errorInfo });
    Sentry.withScope(scope => {
      // $FlowIgnore: `setExtra` has multiple definitions.
      scope.setExtra(errorInfo);
      Sentry.captureException(error);
    });
  }

  render() {
    if (
      isUndefined(window.environment) ||
      window.environment === "debug" ||
      !this.state.error
    ) {
      return this.props.children;
    }

    console.dir(this.state.errorInfo);
    console.dir(this.state.error);
    return (
      <p>
        Something has gone wrong, and it is probably not your fault. We'll email
        you once we figure out what has gone wrong.
      </p>
    );
  }
}
